import { render, staticRenderFns } from "./PaperClip.vue?vue&type=template&id=e9dfa36c&"
import script from "./PaperClip.vue?vue&type=script&lang=ts&"
export * from "./PaperClip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports